import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Paper,
  Typography,
  Avatar,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Icon,
  Divider,
} from "@mui/material";
import {
  Badge as BadgeIcon,
  Work as WorkIcon,
  Apartment as ApartmentIcon,
} from "@mui/icons-material";
import axios from "axios";
import { API_URL } from "../api";

export default function ProfilKaryawan() {
  const navigate = useNavigate();
  const [profil, setProfil] = useState({
    nama: "",
    nik: "",
    jabatan: "",
    departemen: "",
    foto: "https://randomuser.me/api/portraits/men/1.jpg",
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          const userId = parsedUser.nik || "";

          setProfil((prev) => ({
            ...prev,
            nama: parsedUser.nama || "",
            nik: parsedUser.nik || "",
            jabatan: parsedUser.jabatan || "",
          }));

          if (userId) {
            try {
              const res = await axios.get(`${API_URL}/profile-photo/${userId}`);
              if (res.data.success && res.data.base64Image) {
                localStorage.setItem("hasProfileImage", "true");
                setProfil((prev) => ({
                  ...prev,
                  foto: res.data.base64Image,
                }));
              } else {
                const hasProfileImage = localStorage.getItem("hasProfileImage");
                if (hasProfileImage === "true") {
                  localStorage.removeItem("hasProfileImage");
                }
              }
            } catch (imgError) {
              console.error("Gagal memuat foto profil:", imgError);
            }
          }
        } else {
          setModalMsg("Data profil tidak ditemukan.");
          setModalOpen(true);
        }
      } catch (err) {
        console.error("Gagal memuat data profil:", err);
        setModalMsg("Gagal memuat data profil.");
        setModalOpen(true);
      }
    };

    fetchProfileData();
  }, []);

  return (
    <div className="form-container">
      <header className="app-header">
        <div className="header-content">
          <button
            className="back-button"
            onClick={() => navigate("/profil-menu")}
          >
            <Icon>arrow_back</Icon>
          </button>
          <h1 className="header-title"> Profil Karyawan</h1>
          <div className="header-spacer"></div>
        </div>
      </header>
      <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
        {/* Header Biru */}
        <Box sx={{ backgroundColor: "#3498db", py: 4, color: "white" }}>
          <Container sx={{ textAlign: "center" }}>
            <Avatar
              src={profil.foto}
              sx={{
                width: 100,
                height: 100,
                margin: "0 auto",
                border: "3px solid white",
              }}
            />
            <Typography variant="h6" sx={{ mt: 2 }}>
              {profil.nama}
            </Typography>
            <Typography variant="body2">{profil.jabatan}</Typography>
          </Container>
        </Box>

        {/* Konten Profil */}
        <Container sx={{ mt: 3 }}>
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: "bold", fontSize: 18 }}
            >
              Data Informasi Karyawan
            </Typography>
            <Divider sx={{ my: 2 }} />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <BadgeIcon color="primary" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      NIK
                    </Typography>
                    <Typography>{profil.nik}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <WorkIcon color="success" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Jabatan
                    </Typography>
                    <Typography>{profil.jabatan}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <ApartmentIcon color="warning" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Departemen
                    </Typography>
                    <Typography>Development</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        {/* Modal Pesan */}
        <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
          <DialogTitle>Informasi</DialogTitle>
          <DialogContent>
            <Typography>{modalMsg}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setModalOpen(false)}>Tutup</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
}
